import AppSection from 'components/AppSection'
import React from 'react'
import styled from 'styled-components'

export interface AppHeaderProps {
  logo?: string
  title?: string
}

const AppHeader = ({
  logo,
  title = 'Public Water System',
  ...rest
}: AppHeaderProps) => {
  return (
    <Container as="header" {...rest}>
      <Title style={{ flex: 1 }}>
        {logo && <Logo alt="" src={logo} />}
        {title}
      </Title>
    </Container>
  )
}

const Container = styled(AppSection)`
  flex-direction: row;
  justify-content: center;
  padding: calc(var(--gap) * 0.5) calc(var(--gap) * 0.75);
`

const Title = styled.h1`
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 20px;
  font-weight: 400;
`

const Logo = styled.img`
  max-height: 50px;
  width: auto;
  margin-right: 1rem;
`

export default AppHeader
